import React from 'react';
import Loadable from '@components/Loadable';
import { lazy } from 'react';

const Transactions = Loadable(lazy(() => import('./Transactions')));

const accountingRouters = [{ path: '/accounting/transactions', element: <Transactions /> }];

export default accountingRouters;
